import IdentifierRow from './IdentifierRow';

export default IdentifierRow;
